<template>
  <div>
    <main-header/>
    <div class="solid-bg pb-5">
      <nav-bar class="d-md-block d-none"/>
      <div class="container currentBag-grayBorder p-0">
        <div class="gray-bg">
          <div class="text-center font-18  py-5"> ویرایش اطلاعات</div>
        </div>
        <div class="row p-3 ">
          <div class="col-sm-6 col-12 text-center">
            <div class="mt-5">نام</div>
            <div>
              <v-text-field
                  v-model="userName"
                  class="mt-2"
                  dense
                  solo
              ></v-text-field>
            </div>
            <div class="mt-5">پسورد</div>
            <div>
              <v-text-field
                  v-model="userPassword"
                  :rules="PasswordRules"
                  class="mt-2"
                  dense
                  solo
                  type="password"
              ></v-text-field>
            </div>
            <div class="mt-5"> موبایل</div>
            <div>
              <v-text-field
                  v-model="userMobile"
                  :rules="phoneNumberRules"
                  class="mt-2"
                  dense
                  readonly
                  solo
              ></v-text-field>
            </div>
            <div class="mt-5"> کد ملی</div>
            <div>
              <v-text-field
                  v-model="userNationalCode"
                  :rules="nationalCodeRules"
                  class="mt-2"
                  dense
                  solo
              ></v-text-field>
            </div>
          </div>
          <div class="col-sm-6 col-12 text-center">
            <div class="mt-5">نام خانوادگی</div>
            <div>
              <v-text-field
                  v-model="userLastName"
                  class="mt-2"
                  dense
                  solo
              ></v-text-field>
            </div>
            <div class="mt-5">تکرار پسورد</div>
            <div>
              <v-text-field
                  v-model="userRepeatPassword"
                  :rules="repeatPasswordRules.concat(passwordConfirmationRule)"
                  class="mt-2"
                  dense
                  solo
                  type="password"
              ></v-text-field>
            </div>
            <div class="mt-5"> ایمیل</div>
            <div>
              <v-text-field
                  v-model="userEmail"
                  :rules="emailRules"
                  class="mt-2"
                  dense
                  solo
              ></v-text-field>
            </div>
          </div>
        </div>
        <div class="m-3">
          <v-btn
              block
              color="secondary"
              elevation="0"
              @click="setProfileData">
            ویرایش حساب کاربری
          </v-btn>
        </div>
      </div>

    </div>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="goToHome">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <Footer/>
    <NavigationDrawer/>
  </div>
</template>

<script>
let _this = null
import NavBar from "./navBar";
import MainHeader from "./mainHeader";
import Footer from "./Footer";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "profile",
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavigationDrawer, Footer, MainHeader, NavBar},
  data: () => ({
    showLoaderDialog: false,
    userId: null,
    userName: null,
    userEmail: null,
    userRepeatPassword: null,
    userLastName: null,
    userNationalCode: null,
    userMobile: null,
    showResultDialog: false,
    dialogResult: null,
    userPassword: null,
    PasswordRules: [v => !!v || "ورود رمز عبور الزامی است", v => (v && v.length >= 6) || "طول رمز عبور باید بیشتر از 6 رقم باشد"],
    repeatPasswordRules: [v => !!v || "ورود تکرار رمز عبور الزامی است"],
    nationalCodeRules: [
      value => (value && value.length === 10) || 'کد ملی 10 رقم است.',
    ],
    emailRules: [
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'ایمیل نامعتبر'
      }
    ],
    phoneNumberRules: [
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
  }),
  computed: {
    passwordConfirmationRule() {
      return () =>
          this.userPassword === this.userRepeatPassword || "تکرار رمز عبور با رمز عبور یکسان نیست";
    }
  },
  mounted() {
    _this = this
    this.getProfileData()
  },
  methods: {
    goToHome() {
      _this.showResultDialog = false;
      _this.$router.replace({path: "Home"});
    },
    getProfileData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    /*  let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.$getUserData().mobile);*/

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Individual/GetProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            let json = JSON.parse(result)
            console.log(json)
            _this.userId = json.UserName;
            _this.userName = json.Name;
            _this.userEmail = json.Email;
            _this.userPassword = json.Password;
            _this.userRepeatPassword = json.ConfirmPassword;
            _this.userLastName = json.Family;
            _this.userNationalCode = json.NationalCode;
            _this.userMobile = json.PhoneNumber;
            this.showLoaderDialog = false


          })
          .catch(error => console.log('error', error));
    },
    setProfileData() {
      this.showLoaderDialog = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("UserName", this.userId);
      urlencoded.append("Email", this.userEmail);
      urlencoded.append("Password", this.userPassword);
      urlencoded.append("ConfirmPassword", this.userRepeatPassword);
      urlencoded.append("Name", this.userName);
      urlencoded.append("Family", this.userLastName);
      urlencoded.append("NationalCode", this.userNationalCode);
      urlencoded.append("PhoneNumber", this.userMobile);
      urlencoded.append("IsActive", "true");

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Individual/SaveProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            _this.showResultDialog = true
            _this.dialogResult = result


          })
          .catch(error => console.log('error', error));
    }

  }
}
</script>

<style scoped>

</style>
